export function currencyStringToNumber(currencyString: string): number {
    if (currencyString === null || currencyString === undefined) {
        return 0;
    }
    return Number(currencyString.replace(/[^0-9.]+/g, ""))
} 